import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { useCommon } from "../context/CommonContext";
import { useLanguage } from "../context/LanguageProvider";

// IPG Component: A simple reaction time game where a player must press SPACE quickly after seeing a signal ("X")
const IPG = () => {

    console.log("------------------ipg rendered----------------------");

    // Configuration for timing and game parameters
    const config = {
        words: ['X'],                
        minReactionTime: 1,          // Minimum valid reaction time (ms)
        maxReactionTime: 1000,       // Maximum allowed reaction time (ms)
        // preparationTime: 3000,
        // delayBetweenWords: 200,
        // delayedPlusMinus: 25,
        totalWords: 5,               // Number of stimuli to display in a game
        delayBetweenWordsMin: 1000,  // Random delay range between stimuli
        delayBetweenWordsMax: 1500,
        startGameTime: 2000,         // Delay before game starts after first render
        inactivityTime: 240000       // Show inactivity message after 4 minutes of no interaction
    };

    // State variables for game logic & status
    const [isRunning, setIsRunning] = useState(false); // Whether game is active
    const [displayText, setDisplayText] = useState(''); // Currently displayed stimulus
    const [message, setMessage] = useState('');         // Feedback message to the player
        //const [results, setResults] = useState([]);
    const [wordsDisplayed, setWordsDisplayed] = useState(0); // Number of stimuli shown so far
        // const [showNextButton, setShowNextButton] = useState(false);
    // const [showResults, setShowResults] = useState(false);
    const [isWordDisplaying, setIsWordDisplaying] = useState(false); // Whether stimulus is currently visible
    const [isTransitioning, setIsTransitioning] = useState(false);   // Delay period before next word
    const [isInactive, setIsInactive] = useState(false); // Inactivity warning visibility
    const [message1, setMessage1] = useState(''); // Instructional/Error heading message
    const [message2, setMessage2] = useState(''); // Additional instruction message
    const [consecutiveGoodReactions, setConsecutiveGoodReactions] = useState(0); // Track consecutive correct plays
    const [isKeyTrackingDisabled, setIsKeyTrackingDisabled] = useState(false); // Prevent further inputs after success

    // Refs to persist values without causing re-render
    const startTimeRef = useRef(null);        // Time when a stimulus appears
    const wordTimeoutRef = useRef(null);      // Timeout to detect missed reaction
    const currentWordRef = useRef(null);      // Currently displayed word
    const delaywordRef = useRef(null);        // Delay before showing next stimulus
    const inactivityTimerRef = useRef(null);  // Detect player inactivity
    const resultsRef = useRef([]);            // Store reaction times

    const navigate = useNavigate();

    const { setPracticeReaction, kioskTimeoutText } = useCommon();
    const { translation } = useLanguage();

    // On mount: start game after a delay
    useEffect(() => {
        const timer = setTimeout(() => {
            start();
        }, config.startGameTime);

        return () => clearTimeout(timer);
    }, []);

    // Show a message to the player, optionally flagged as an error
    const showMessage = (text, isError = false) => {
        console.log(`showMessage called with text: "${text}", isError: ${isError}`);
        setMessage(text);
        setMessage1('');
        setMessage2('');
        if (isError) {
            // Show localized error instructions
            setMessage1(translation("IPG_mistakeMessage"));
            setMessage2(translation("IPG_focusReminder"));
        }
    };

    // Display a stimulus word ("X") and start timing the player’s reaction
    const displayWord = () => {
        console.log(`displayWord called. Words displayed: ${wordsDisplayed}`);
        if (wordsDisplayed < config.totalWords) {
            const currentWord = config.words[Math.floor(Math.random() * config.words.length)];
            currentWordRef.current = currentWord;
            setDisplayText(currentWord);
            setIsWordDisplaying(true);
            setIsTransitioning(false);
            startTimeRef.current = performance.now();
            console.log(`Displaying word: "${currentWord}"`);

            // Player must react before maxReactionTime or it's a miss
            wordTimeoutRef.current = setTimeout(() => {
                console.log("too slow message from displayWord");
                // const errorResult1 = 'Error: Missed X';
                // setResults(prev => [...prev, errorResult1]); // Add error reaction time to results
                // showMessage('Please press space within 1sec, Press SPACE to try again or Next to move forward.', true);    
                showMessage(translation("IPG_missedInstruction"), true);
                end(true);
            }, config.maxReactionTime);
        } else {
            // No more words left: end game
            console.log('All words displayed. Ending the game.');
            end(false);
        }
    };

    // Start/reset the game state
    const start = () => {
        console.log('Game started.');
        setIsRunning(true);
        // setResults([]);
        setWordsDisplayed(1);
        setDisplayText('');
                // setShowNextButton(false);
        // setShowResults(false);
        showMessage('');
                console.log(`inside start ${isRunning}`);
        // let countdown = Math.ceil(config.preparationTime / 1000);
        // const countdownInterval = setInterval(() => {
        //     if (countdown > 0) {
        //         setDisplayText(countdown.toString());
        //         console.log(`Countdown: ${countdown}`);
        //         countdown--;
        //     } else {
        //         clearInterval(countdownInterval);
        //         displayWord();
        //     }
        // }, 1000);
        displayWord();
    };
        // const next = () => {
    //     console.log('Navigating to next page.');
    //     navigate('/IMGI1');
    // };

    // End the game or trial, optionally due to a bad reaction
    const end = (badReaction) => {
        clearTimeout(delaywordRef.current);
        setWordsDisplayed(0);
                console.log('Game ended.');
        setIsRunning(false);
                // setShowNextButton(true);
        setIsTransitioning(false);
        if (wordTimeoutRef.current) clearTimeout(wordTimeoutRef.current);
        setDisplayText('');
                // setShowResults(true);

        console.log(badReaction);
        console.log(consecutiveGoodReactions);

        // Restart streak on error, otherwise check for game completion
        if (badReaction) {
            setConsecutiveGoodReactions(0);
        } else {
            if (consecutiveGoodReactions + 1 >= config.totalWords) {
                setIsKeyTrackingDisabled(true);
                                console.log(isKeyTrackingDisabled);
                showMessage("");
                setPracticeReaction(resultsRef.current.slice(-5));
                navigate('/IMGI1');
            }
        }
    };

    // Handle spacebar presses as game input
    const handleSpacePress = (event) => {
                console.log('Space key pressed.');
        resetInactivityTimer(); // Any keypress resets inactivity timer

                if (isKeyTrackingDisabled) {
            console.log('Key tracking is disabled. Ignoring key press.');
            return; // Ignore key presses if tracking is disabled
        }

        if (event.code === 'Space') {
            event.preventDefault();

            // Prevent premature presses between words
            if (isTransitioning) {
                                console.log('Transitioning, ignoring space key.');
                // const errorResult2 = 'Error: Pressed space when no "X" displayed';
                // setResults(prev => [...prev, errorResult2]); // Add error reaction time to results
                showMessage(translation("IPG_noXInstruction"), true);
                end(true);
                // return; // Do nothing during transition
            }

            // Start the game if not running yet
            if (!isRunning) {
                                console.log('Starting the game.');
                start();
            } else if (startTimeRef.current && isWordDisplaying) {
                // Record valid reaction time
                setIsWordDisplaying(false);
                const reactionTime = performance.now() - startTimeRef.current;
                                console.log(`Reaction time recorded: ${reactionTime}ms`);
                handleResponse(reactionTime);
            }
        }
    };

    // Reset inactivity timer, showing warning after no input
    const resetInactivityTimer = () => {
        if (inactivityTimerRef.current) {
            clearTimeout(inactivityTimerRef.current);
        }
        setIsInactive(false);
        inactivityTimerRef.current = setTimeout(() => {
            setIsInactive(true);
        }, config.inactivityTime);
    };

    // Process player reaction time and decide if it's a hit/miss
    const handleResponse = (reactionTime) => {
                console.log(`handleResponse called with reactionTime: ${reactionTime}`);
                        if (wordTimeoutRef.current) clearTimeout(wordTimeoutRef.current);

        if (reactionTime < config.minReactionTime) {
            showMessage(translation("IPG_tooEarlyMessage"), true);
            end(true);
        } else if (reactionTime > config.maxReactionTime) {
            showMessage(translation("IPG_missedInstruction"), true);
            end(true);
        } else {
            // Valid reaction
            const roundedReactionTime = Math.round(reactionTime * 100) / 100;
            resultsRef.current.push(roundedReactionTime);
                        //setResults(prev => [...prev, reactionTime.toFixed(2)]); // Add reaction time to results
            // setResults(prev => [...prev, `Reaction time: ${reactionTime}ms`]);

            // showMessage(`Good! Reaction time: ${reactionTime}ms`);
            setDisplayText('');
            setWordsDisplayed(prev => prev + 1);
            setIsTransitioning(true);

            // Wait random delay before showing next word
                        // const randomDelay = config.delayBetweenWords + (Math.random() < 0.5 ? -config.delayedPlusMinus : config.delayedPlusMinus);
            // console.log(`random delay ${randomDelay}`);
            const randomDelay2 = (Math.random() * 
                (config.delayBetweenWordsMax - config.delayBetweenWordsMin) +
                config.delayBetweenWordsMin);
                            console.log(`random delay ${randomDelay2}`);
            delaywordRef.current = setTimeout(() => {
                if (isRunning) {
                    setConsecutiveGoodReactions(prev => prev + 1);
                    displayWord();
                }
            }, randomDelay2);
        }
    };

    // Bind input & inactivity events
    useEffect(() => {
        document.addEventListener('keydown', handleSpacePress);

        const preventScroll = (e) => {
            if (e.code === 'Space' && e.target === document.body) {
                e.preventDefault();
            }
        };
        window.addEventListener('keydown', preventScroll);

        resetInactivityTimer();

        // Mouse movement also counts as activity
        const handleMouseMove = () => resetInactivityTimer();
        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            document.removeEventListener('keydown', handleSpacePress);
            window.removeEventListener('keydown', preventScroll);
            window.removeEventListener('mousemove', handleMouseMove);
            clearTimeout(inactivityTimerRef.current);
        };
    }, [isRunning, isWordDisplaying, isTransitioning]);

    // Render game UI: messages, stimulus, inactivity warning
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <div className="text-center p-6">

                {/* Main error/instruction heading */}
                <div className="text-red-600 mb-8 text-left font-bold left-0 text-3xl">
                    {message1}
                </div>

                {/* Feedback message list */}
                {message && (
                    <ul className="list-disc mb-8 w-full ml-4 pl-2 text-left text-2xl font-medium">
                        <li>{message}</li>
                    </ul>
                )}

                {/* Secondary instruction */}
                <div className="mb-7 text-left left-0 text-2xl font-medium">
                    {message2}
                </div>

                {/* Display stimulus (X) */}
                <div className="fixed inset-0 flex items-center justify-center text-6xl">
                    {displayText}
                </div>

                {/* Inactivity overlay */}
                {isInactive && (
                    <div className="fixed inset-0 flex items-center justify-center bg-yellow-200">
                        <p className="text-5xl font-bold">{kioskTimeoutText.current}</p>
                    </div>
                )}
                {/* Buttons */}
                {/* {showNextButton && (
                    <div className="flex justify-center space-x-4">
                        <button 
                            onClick={next} 
                            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition duration-200"
                        >
                            Next
                        </button>
                    </div>
                )} */}

                {/* Results Area */}
                {/* {showResults && resultsRef.current.length > 0 && (
                    <div className="mt-6 bg-white p-6 rounded-lg shadow-md">
                        <h2 className="text-xl font-semibold mb-4">This screen is currently used for testing purpose, will be removed in the final version</h2>
                        <h2 className="text-xl font-semibold mb-4">Your Results:</h2>
                        <ul>
                            {resultsRef.current.map((result, index) => (
                                <li key={index}>
                                    Reaction Times: {result}
                                </li>
                            ))}
                        </ul>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default IPG;